<template>
    <div id="device-card">   

        <!-- card -->
        <div style="width:100%; float:left; background-color: white;">

            <div v-if="item.id =='Packaging Device 1' || item.id =='Packaging Device 2' || item.id =='Packaging Device 3'" class='img-container'>
                <img v-if="item.online" class="card-background card-img-top online" src="../../assets/images/sensor-online.png" alt="...">
                <img v-else class="card-background card-img-top" src="../../assets/images/smart-packaging-offline.png" alt="...">
            </div> 
            
            <div v-else-if="item.id =='BioThaw-Vitrafy-00004'" class='img-container'>
                <img v-if="item.online" class="card-background card-img-top online" src="../../assets/images/bio_thawer.png" alt="...">
                <img v-else class="card-background card-img-top" src="../../assets/images/bio_thawer_offline.png" alt="...">
            </div>

            <div v-else-if="item.id =='VLSENGNB011'" class='img-container'>
                <img v-if="item.online" class="card-background card-img-top online" src="../../assets/images/laptop.png" alt="...">
                <img v-else class="card-background card-img-top" src="../../assets/images/laptop-offline.png" alt="...">
            </div>
                      
            <div v-else class='img-container'>
                <img v-if="item.online" class="card-background card-img-top online" src="../../assets/images/4-new.png" alt="...">
                <img v-else class="card-background card-img-top" src="../../assets/images/4-new-offline.png" alt="...">                                        
            </div>

            <div class="content-container">
                <h5 class="card-title offline">
                    <div v-if="item.id == 'BioThaw-Vitrafy-00004'">BioThaw-00004</div> <!-- adjust BioThaw-Vitrafy-00004 name to fit in card -->
                    <div v-else-if="item.id == 'Packaging Device 3'">Sensor 2</div>
                    <div v-else-if="item.id == 'Packaging Device 2'">Sensor 1</div>
                    <div v-else>{{ item.id }}</div>
                </h5>
                <p class="card-text offline">
                    <!-- {{ item.details }}<br /> -->
                    Temperature and Humidity<br />
                    <span v-if="item.online" class="badge bg-success">Online</span>
                    <span v-else class="badge bg-secondary">Offline</span>
                </p>

                <div v-if="item.id == 'Vitrafy-00001'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[0].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[0].belowZero" class="" src="../../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[0].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[0].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-if="item.id == 'Vitrafy-00002'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[1].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[1].belowZero" class="" src="../../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[1].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[1].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-else-if="item.id == 'Vitrafy-00004'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[2].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[2].belowZero" class="" src="../../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[2].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[2].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-else-if="item.id == 'Vitrafy-00006'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[3].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[3].belowZero" class="" src="../../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[3].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[3].flow }} L/min
                        </div>
                    </div>
                </div>
                <div v-else-if="item.id == 'Vitrafy-00009'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData" :class="[$parent.deviceTempAndFlow[7].belowZero ? 'belowZero' : '']">
                            <img v-if="$parent.deviceTempAndFlow[7].belowZero" class="" src="../../assets/images/snowflake.png" alt="...">
                            {{ $parent.deviceTempAndFlow[7].temp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ $parent.deviceTempAndFlow[7].flow }} L/min
                        </div>
                    </div>
                </div>

                <div v-else-if="item.id == 'Packaging Device 2' || item.id == 'Packaging Device 3'">
                    <div v-if="item.online" class="bigTempDataContainer">
                        <div class="bigTempData">
                            {{ item.SensorTemp }} °C
                        </div>
                        <div class="smallTempData">
                            {{ item.SensorRH }} % rh
                        </div>
                    </div>
                </div>

                <div v-else>
                    <!-- currently empty -->
                </div>
            </div>
        </div>
        <div class="card-footer" style="width: 100%; float:left; position: relative; background-color: #F7F7F7">
            <router-link to="/Device5" v-if="item.id != 'Raspberry-Pi-2'">
                <button type="button" class="btn btn btn-outline btn-sm action-button disabled"><span style="color: #F7F7F7;">DATA</span></button>
            </router-link>         

            <!-- Packaging Device 2 & Packaging Device 2 -->
            <div v-if="item.id == 'Packaging Device 2' || item.id == 'Packaging Device 3'">
                <button v-b-modal="'device-pi-data-modal' + item.id" @click="pi2DataClick()" type="button" class="btn btn-outline-primary btn-sm action-button data-button" style="position: absolute; right: 80px"><i class="fa-solid fa-chart-simple"></i><span style="padding-left:10px">Data</span></button>
            </div>

            <!-- Vitrafy-00001 or Vitrafy-00002 or Vitrafy-00004 or Vitrafy-00006 or Vitrafy-00009-->
            <div v-if="item.id == 'Vitrafy-00001' || item.id == 'Vitrafy-00002' || item.id == 'Vitrafy-00004' || item.id == 'Vitrafy-00006' || item.id == 'Vitrafy-00009'">
                <button v-b-modal="'device-data-modal' + item.id" type="button" class="btn btn-outline-primary btn-sm action-button data-button" style="position: absolute; right: 80px" @click="deviceDataShow()"><i class="fa-solid fa-chart-simple"></i><span style="padding-left:10px">Data</span></button>
            </div>

            <!-- info (all) -->
            <button type="button" v-b-modal="'device-info-modal' + item.id" class="btn btn-outline-primary btn-sm action-button data-button" style="position: absolutel; right: 0"><i class="fa-solid fa-circle-info"></i><span style="padding-left:10px">Info</span></button>

        </div> 
        <!-- END card -->

        <!-- info modal -->
        <b-modal :id="'device-info-modal' + item.id" size="lg">
            <!-- title -->
            <template #modal-title>
                <i class="fa-solid fa-circle-info"></i>
                <span v-if="item.id == 'Packaging Device 3'" class="modal-title">Info - Sensor 2</span>
                <span v-if="item.id == 'Packaging Device 2'" class="modal-title">Info - Sensor 1</span>
            </template>

            <!-- info container -->
            <div>
                <!-- image -->
                <div style="float: left; margin-right: 20px;">
                    <div v-if="item.id =='Packaging Device 1' || item.id =='Packaging Device 2' || item.id =='Packaging Device 3'" class='img-container'>
                        <img v-if="item.online" class="card-background card-img-top online" src="../../assets/images/sensor-online.png" alt="...">
                        <img v-else class="card-background card-img-top" src="../../assets/images/smart-packaging-offline.png" alt="...">
                    </div> 
                    
                    <div v-else-if="item.id =='BioThaw-Vitrafy-00004'" class='img-container'>
                        <img v-if="item.online" class="card-background card-img-top online" src="../../assets/images/bio_thawer.png" alt="...">
                        <img v-else class="card-background card-img-top" src="../../assets/images/bio_thawer_offline.png" alt="...">
                    </div>

                    <div v-else-if="item.id =='VLSENGNB011'" class='img-container'>
                        <img v-if="item.online" class="card-background card-img-top online" src="../../assets/images/laptop.png" alt="...">
                        <img v-else class="card-background card-img-top" src="../../assets/images/laptop-offline.png" alt="...">
                    </div>
                            
                    <div v-else class='img-container'>
                        <img v-if="item.online" class="card-background card-img-top online" src="../../assets/images/4-new.png" alt="...">
                        <img v-else class="card-background card-img-top" src="../../assets/images/4-new-offline.png" alt="...">                                        
                    </div>
                </div>                    

                <!-- table -->
                <div style="float: left; max-width: 600px;">
                    <table class="table">
                        <tbody>
                            <tr class="">
                                <td>Device Name</td>
                                <td v-if="item.id == 'Packaging Device 3'">Sensor 2</td>
                                <td v-if="item.id == 'Packaging Device 2'">Sensor 1</td>
                            </tr>
                            <tr class="">
                                <td>Device Type</td>
                                <td>Temperature and Humidity Sensor</td>
                            </tr>
                            <tr class="">
                                <td>Location</td>
                                <td v-if="item.id == 'Packaging Device 3'">Vitrafy Manufacturing Area</td>
                                <td v-if="item.id == 'Packaging Device 2'">Vitrafy Design Lab</td>
                            </tr>                            
                            <tr v-if="item.online" class="">
                                <td>Status</td>
                                <td>
                                    <span v-if="item.online" class="badge bg-success">Online</span>
                                    <span v-else class="badge bg-secondary">Offline</span>
                                </td>
                            </tr>
                            <tr v-else class="">
                                <td>Status</td>
                                <td>
                                    <span v-if="item.online" class="badge bg-success">Online</span>
                                    <span v-else class="badge bg-secondary">Offline</span>
                                </td>
                            </tr>
                            <tr v-if="item.online" class="">
                                <td>Uptime</td>
                                <td>{{ item.deviceUptime }}</td>
                            </tr>                            
                            <tr class="">
                                <td>Last Communication</td>
                            <td>
                                    {{ item.convertedTimestamp }} <br /> 
                                    <!-- {{ item.lastCommunicationSeconds }} seconds ago <br /> -->
                                    {{ item.formattedLastCommunicationSeconds }}<br />
                            </td>
                            </tr>                            
                            <tr class="">
                                <td>LifeLink Version</td>
                                <td v-if="item.lifeLinkUpToDate">
                                    {{ item.lifelinkVersion }} <b-alert style="margin: 0; padding: 0; display: inline-block; padding-left: 4px; padding-right: 5px; margin-left: 10px;" show variant="success"><font-awesome-icon icon="fa-solid fa-check" /><span> Up to date</span></b-alert>
                                </td>
                                <td v-else>
                                    {{ item.lifelinkVersion }} <b-alert style="margin: 0; padding: 0; display: inline-block; padding-left: 4px; padding-right: 5px; margin-left: 10px;" show variant="warning"><font-awesome-icon icon="fa-solid fa-exclamation-circle" /><span> Update Required <a href="#">update now</a></span></b-alert>
                                </td>                                
                            </tr>
                            <tr>
                                <td>Device Information</td>
                                <td>
                                    <table id="info-table" v-bind:class="{'whiteTable':!item.online}" style="margin-bottom: 0px;">
                                        <tr>
                                            <td class="info-title">CPU</td>
                                            <td style="padding-left: 5px;">{{ item.deviceCPU }}%</td>
                                            <td class = "chart">
                                                <div class="progress" v-bind:class="{'hide-element':item.offline}">
                                                    <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.deviceCPU + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="info-title">MEM</td>
                                            <td style="padding-left: 5px;">{{ item.deviceMEM }}%</td>
                                            <td class = "chart">
                                                <div class="progress" v-bind:class="{'hide-element':item.offline}">
                                                    <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.deviceMEM + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                        </tr> 
                                        <tr v-if="item.sensorDevice && item.online" class="info-title">
                                            <td>SENSOR</td>
                                            <td colspan="2" style="padding-left: 5px;">{{ item.sensorData }} (DHT22 temperature-humidity sensor)</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div> 

            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('device-info-modal' + item.id)">Close</button>
            </template>
        </b-modal>

        <!-- pi data modal -->
        <b-modal :id="'device-pi-data-modal' + item.id" scrollable size="xl" @hide="pi2DataHide()">
            <!-- title-->
            <template #modal-title>
                <i class="fa-solid fa-chart-simple"></i>
                <span v-if="item.id == 'Packaging Device 3'" class="modal-title">Data - Sensor 2</span>
                <span v-if="item.id == 'Packaging Device 2'" class="modal-title">Data - Sensor 1</span>
            </template>

            <div>
                <!-- loading spinner -->
                <div id="live-data-loading">
                    <div class="lds-facebook"><div></div><div></div><div></div></div>
                    <div>Connecting to live data feed...</div>
                </div>

                <!-- live data content -->
                <div v-if="autoFetchData" id="live-data-container" style="display: none;">

                    <!-- Live icon (flashing) -->
                    <div style="position: relative;padding-left:20px;">
                        <span style="color:red; font-weight: bold;">LIVE DATA</span>
                        <svg height="50" width="50" class="blinking" style="position:absolute; top:-9px; left:-11px;">
                            <circle cx="20" cy="20" r="5" fill="red" />
                        </svg> 
                    </div>

                    <br />

                    <div style="float:left; width:100%; margin-bottom: 40px;">
                        <!-- device location desktop -->
                        <div id="device-location-desktop" style="display: inline-block; width: 50%; padding-right: 20px; float: left;">
                            <!-- <h4>Location</h4> -->
                            <h4 v-if="item.id == 'Packaging Device 3'" class="modal-title">Location - Vitrafy Manufacturing Area</h4>
                            <h4 v-if="item.id == 'Packaging Device 2'" class="modal-title">Location - Vitrafy Design Lab</h4>
                            <PackagingTracking ref="PackagingTracking"/>
                            
                        </div>
                        <!-- device data -->
                        <div id="device-data" style="display: inline-block; width: 50%; padding-left: 20px; float: left;">
                            <h4>Sensor Data</h4>
                            <!-- Temperature Chart -->
                            <div>
                                <div style="position: relative;">
                                    <h1 style="font-size: 48px; margin-bottom: 0; text-align: right; padding-right: 48px; padding-top: 0 !important;"> 
                                        <span v-if="temperatureChange == 'D'" style="color: red" >{{ temperature }} °C</span>
                                        <span v-if="temperatureChange == 'U'" style="color: green" >{{ temperature }} °C</span>
                                        <span v-if="temperatureChange == '-'">{{ temperature }} °C</span>
                                    </h1>
                                    <div style="position: absolute; bottom: 0; right: 10px; font-size: 48px; padding-top: 0 !important;">
                                        <font-awesome-icon v-if="temperatureChange == 'D'" icon="fa-solid fa-caret-down" style="color: red" />
                                        <font-awesome-icon v-if="temperatureChange == 'U'" icon="fa-solid fa-caret-up" style="color: green"/>
                                    </div>                                    
                                    <div style="position: absolute; bottom: 9px; right: 10px; font-size: 48px;">
                                        <font-awesome-icon v-if="temperatureChange == '-'" icon="fa-solid fa-minus" style="font-size:25px;"/>         
                                    </div>                                                                        
                                </div>
                                <div style="text-align: right; text-transform: uppercase; margin-bottom: 15px; padding-right: 10px;">temperature</div>                                
                                <div style="width:50%; height: 200px">
                                    <canvas id="device-chart"></canvas>
                                </div>               
                            </div>   

                            <!-- Humidity  Chart -->
                            <div>
                                <div style="position: relative;">
                                    <h1 style="font-size: 48px; margin-bottom: 0; text-align: right; padding-right: 48px;"> 
                                        <span v-if="humidityChange == 'D'" style="color: red" >{{ humidity }} %</span>
                                        <span v-if="humidityChange == 'U'" style="color: green" >{{ humidity }} %</span>
                                        <span v-if="humidityChange == '-'">{{ humidity }} %</span>
                                    </h1>
                                    <div style="position: absolute; bottom: 0; right: 10px; font-size: 48px;">
                                        <font-awesome-icon v-if="humidityChange == 'D'" icon="fa-solid fa-caret-down" style="color: red" />
                                        <font-awesome-icon v-if="humidityChange == 'U'" icon="fa-solid fa-caret-up" style="color: green"/>
                                    </div>                                    
                                    <div style="position: absolute; bottom: 9px; right: 10px; font-size: 48px;">
                                        <font-awesome-icon v-if="humidityChange == '-'" icon="fa-solid fa-minus" style="font-size:25px;"/>         
                                    </div>                                                                        
                                </div>
                                <div style="text-align: right; text-transform: uppercase; margin-bottom: 15px; padding-right: 10px;">humidity</div>                                
                                <div style="width:50%; height: 200px">
                                    <canvas id="device-chart-2"></canvas>
                                </div>               
                            </div>
                        </div>
                        <!-- device location mobile -->
                        <div id="device-location-mobile" style="display: inline-block; width: 100%; padding: 0px; float: left;">
                            <h4>Location</h4>
                            <PackagingTracking ref="PackagingTracking"/>
                        </div>
                    </div>

                    <!-- data table -->
                    <div style="float:left; width:100%">
                        <table class="table" id="live-data-table" style="float: left; width: 100%">
                            <thead>
                                <tr>
                                    <th>Timestamp</th>
                                    <th>Location</th>
                                    <th>Temperature °C</th>
                                    <th>Humidity %</th>
                                </tr>                               
                            </thead>
                            <tbody>
                                <tr v-for="row in sensorData" v-bind:key="row.ID">
                                    <td> {{ row.timestamp }}</td>
                                    <td> -37.53092219073088, 143.84338591371284 </td>
                                    <td> {{ row.sensorTemp }}</td>
                                    <td> {{ row.sensorHumidity }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

            </div>

            </div>
            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('device-pi-data-modal' + item.id)">Close</button>
            </template>
        </b-modal>

        <!-- data modal -->
        <b-modal :id="'device-data-modal' + item.id" size="xl" class="xxl-modal" scrollable @hide="deviceDataHide()">
            <!-- title-->
            <template #modal-title>
                <i class="fa-solid fa-chart-simple"></i><span class="modal-title">Data - {{ item.id }}</span>
            </template>

            <!-- content -->
            <div>
                <!-- left panel -->
                <div style="float:left; width: 30%;">
                    <!-- info box -->
                    <div style="padding-top: 10px; padding-bottom: 0px;">
                            <img v-if="item.online" style="display: inline-block; width: 65px; vertical-align: top;" src="../../assets/images/4.png" alt="..." />
                            <img v-else style="display: inline-block; width: 65px; vertical-align: top; opacity: 80%" src="../../assets/images/4-offline.png" alt="..." />
                        <div style="display: inline-block; padding-left: 10px;">
                            <b>Device:</b> {{ item.id }}
                            <br />
                            <b>Type:</b> Cryopreservation Apparatus
                            <br />
                            <b>Location:</b> {{ item.location }}
                            <br />
                            <span v-if="item.online" class="badge bg-success">Online</span>
                            <span v-else class="badge bg-secondary">Offline</span>                                              
                        </div>

                        <!-- live temp -->
                        <div style="float: right; padding-right: 30px; margin-top: -10px;">
                            <!-- <div>{{ $parent.deviceTempAndFlow[1].temp }} °C</div> -->
                            <div v-if="item.id == 'Vitrafy-00001'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[0].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[0].belowZero" class="" style="left: -54px; top: 13px; height: 34px;" src="../../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[0].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[0].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.id == 'Vitrafy-00002'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[1].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[1].belowZero" class="" style="left: -54px; top: 13px; height: 34px;" src="../../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[1].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[1].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00004'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[2].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[2].belowZero" class="" style="left: -54px; top: 13px; height: 34px;" src="../../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[2].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[2].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00006'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[3].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[3].belowZero" class="" style="left: -54px; top: 13px; height: 34px;" src="../../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[3].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[3].flow }} L/min
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.id == 'Vitrafy-00009'">
                                <div v-if="item.online" class="bigTempDataContainer">
                                    <div class="bigTempData" :class="[$parent.deviceTempAndFlow[7].belowZero ? 'belowZero' : '']" style="font-size: 39px;">
                                        <img v-if="$parent.deviceTempAndFlow[7].belowZero" class="" style="left: -54px; top: 13px; height: 34px;" src="../../assets/images/snowflake.png" alt="...">
                                        {{ $parent.deviceTempAndFlow[7].temp }} °C
                                    </div>
                                    <div class="smallTempData">
                                        {{ $parent.deviceTempAndFlow[7].flow }} L/min
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- temp chart -->
                    <div style="padding-right: 30px; padding-bottom: 1px;;">
                        <!-- <hr /> -->
                            <DeviceDataRealTime :item="item" ref="DeviceDataRealTime"/>
                        <!-- <hr style="margin-bottom: 0px;"/> -->
                    </div>

                    <!-- device location -->
                    <div id="device-location" style="padding-right: 30px; margin-top: -20px;">
                        <div v-if="item.id == 'Vitrafy-00001'"><PackagingTracking_HuonTas ref="PackagingTracking_HuonTas"/></div>
                        <div v-else-if="item.id == 'Vitrafy-00002'"><PackagingTracking_BioBridge ref="PackagingTracking_BioBridge"/></div>
                        <div v-else><PackagingTracking ref="PackagingTracking"/></div>
                    </div>

                    <!-- system info -->
                    <!-- <div id="data-modal-sys-info" style="padding-right: 30px;">
                        <hr/>
                        <table id="info-table" v-bind:class="{'whiteTable':!item.online}" style="margin-bottom: 0px;">
                            <tr>
                                <td>CPU</td>
                                <td style="padding-left: 10px;">{{ item.deviceCPU }}%</td>
                                <td class = "chart">
                                    <div class="progress" v-bind:class="{'hide-element':item.offline}">
                                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.deviceCPU + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>MEM</td>
                                <td style="padding-left: 10px;">{{ item.deviceMEM }}%</td>
                                <td class = "chart">
                                    <div class="progress" v-bind:class="{'hide-element':item.offline}">
                                        <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.deviceMEM + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </td>
                            </tr> 
                            <tr v-if="item.sensorDevice && item.online" class="info-title">
                                <td>SENSOR</td>
                                <td colspan="2" style="padding-left: 5px;">{{ item.sensorData }} (DHT22 temperature-humidity sensor)</td>
                            </tr>
                        </table>
                    </div> -->

                </div>

                <!-- right panel -->
                <div style="float:left; width: 70%;">
                    <!-- tabs  -->
                    <div style="width: 100%; float: left; overflow: auto">
                        <b-tabs content-class="mt-3">
                            <b-tab title="History (Batches)">

                                <DeviceDataBatches :item="item" :autoUpdateDeviceData="autoUpdateDeviceData"/>

                            </b-tab>
                            <b-tab title="Trends">

                                <DeviceData :item="item" ref="DeviceData"/>

                            </b-tab>
                            <b-tab title="Refrigeration">

                                <DeviceImageData :item="item" ref="DeviceImageData"/>

                            </b-tab>
                        </b-tabs>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('device-data-modal' + item.id)">Close</button>
            </template>
        </b-modal>

        <!-- control  modal -->
        <b-modal :id="'device-control-modal' + item.id" :title="item.id" size="xl" scrollable>
            <div>
                
                <iframe style="width: 100%; height: 750px;" src="http://192.168.1.244:8088/data/perspective/client/Bio_Freeze/menu"></iframe>

            </div>
            <template #modal-footer>
                <button v-b-modal.modal-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('device-control-modal' + item.id)">Close</button>
            </template>
        </b-modal>

    </div>    
</template>

<script>
    //import LiveDataModal from '@/components/LiveDataModal.vue';
    import PackagingTracking from '@/components/PackagingTracking.vue';
    import PackagingTracking_BioBridge from '@/components/PackagingTracking_BioBridge.vue';
    import PackagingTracking_HuonTas from '@/components/PackagingTracking_HuonTas.vue';
    import DeviceDataBatches from '@/components/DeviceData/DeviceDataBatches.vue';
    import DeviceData from '@/components/DeviceData/DeviceData.vue';
    import DeviceDataRealTime from '@/components/DeviceData/DeviceDataRealTime.vue';
    import DeviceImageData from '@/components/DeviceData/DeviceImageData.vue';
    import Chart from 'chart.js';

    export default {
        name: 'sensor-card',
        components: {
    // LiveDataModal,
    // LiveData,
    PackagingTracking,
    PackagingTracking_BioBridge,
    PackagingTracking_HuonTas,
    DeviceData,
    DeviceImageData,
    DeviceDataBatches,
    DeviceDataRealTime
},
        data: function () {
            return {
                sensorData: [],
                patentTest: "this is a parent!",
                SensorData: "", 
                piData: {
                    type: "line",
                    data: {
                        labels: [],
                        datasets: [
                            {
                                label: "Temperature °C",
                                data: [],
                                backgroundColor: "rgba(54,73,93,.5)",
                                borderColor: "#36495d",
                                borderWidth: 3,
                                radius: 0
                            }                  
                        ]
                    },
                    options: {
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },                    
                        animation: {
                            duration: 0
                        },                    
                        responsive: true,
                        lineTension: 1,
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: false,
                                        padding: 25
                                    }
                                }
                            ]
                        }      
                    }
                },
                temperature: null,
                temperatureChange: null,
                piData2: {
                    type: "line",
                    data: {
                        labels: [],
                        datasets: [
                            {
                                label: "Humidity %",
                                data: [],
                                backgroundColor: "rgba(71, 183,132,.5)",
                                borderColor: "#47b784",
                                borderWidth: 3,
                                radius: 0
                            }
                        ]
                    },
                    options: {
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },                       
                        animation: {
                            duration: 0
                        },                    
                        responsive: true,
                        lineTension: 1,
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: false,
                                        padding: 25
                                    }
                                }
                            ]
                        }                     
                    }
                },
                humidity: null,
                humidityChange: null,
                autoFetchData: false,
                autoUpdateDeviceData: false,
                deviceBatchData: [],
            };
        },
        props: ['item'],
        mounted() {
            // Pi Temp sensor API auto-fetch
            this.timer2 = setInterval(() => {
                if(this.autoFetchData) {
                    this.getSensorData();
                }
            }, 1000) // 1 sec

            // device data auto-fetch
            console.log("autoUpdateDeviceData = " + this.autoUpdateDeviceData);
        },        
        methods: {
            deviceDataShow() {
                this.autoUpdateDeviceData = true;
                console.log("device ID = " + this.item.id);
                console.log("autoUpdateDeviceData = " + this.autoUpdateDeviceData);
            },            
            deviceDataHide() {
                this.autoUpdateDeviceData = false;
                console.log("autoUpdateDeviceData = " + this.autoUpdateDeviceData);
            },
            pi2DataClick(){
                console.log("MODAL opened!");
                this.autoFetchData = true;
                scroll(0,0);
                //this.$parent.pi2DataClick();
            },
            pi2DataHide(){
                console.log("MODAL closed!");
                this.autoFetchData = false;
                //this.$parent.pi2DataHide();
            },
            async getSensorData() {
                // for Packaging Device 2
                let url = "https://xct6d7fy58.execute-api.ap-southeast-2.amazonaws.com/beta"; 

                // for Packaging Device 3
                if(this.item.id == "Packaging Device 3") {
                    url = "https://s9tfb3de53.execute-api.ap-southeast-2.amazonaws.com/default"; 
                }

                let headers = {
                    'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                };                

                try {
                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );

                    //console.log(response.data.Items[0].itemData[29]);

                    var sensorDataArray = [];
                    var datasetZero = [];
                    var datasetOne = [];
                    var labels = [];

                    // console.log("---DEBUG---")
                    // console.log(response.data);
                    // console.log("---END DEBUG---")


                    for(var i = 0; i < response.data.Items[0].itemData.length; i++) {

                        // tempdata object
                        var tempData = response.data.Items[0].itemData[i].deviceTempData.split(" "); // example "1650500757 21.2 49.""

                        // format timestamp
                        var adjustedTimestamp = parseInt(tempData[0] + "000");

                        var ts = new Date(parseInt(adjustedTimestamp));
                        //console.log(ts);

                        var tsa = ts.toLocaleString('en-AU').toUpperCase();
                        var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                        var tsc = tsb.replace(',', '');

                        var sensorData = {
                            timestamp: tsc,
                            sensorTemp: tempData[1],
                            sensorHumidity: tempData[2],
                        }

                        sensorDataArray.push(sensorData);
                        datasetZero.push(tempData[1]);
                        datasetOne.push(tempData[2]);

                        var cts = ts.toString().split(' ');
                        labels.push(cts[4]);
                    }

                    // data for table
                    this.sensorData = sensorDataArray.reverse();

                    // data for chart and redraw chart
                    this.piData.data.labels = labels;
                    this.piData.data.datasets[0].data = datasetZero;
                    this.temperature = datasetZero[29];

                    if(this.temperature > datasetZero[28]) {
                        this.temperatureChange = "U"
                    } else if(this.temperature < datasetZero[28]) {
                        this.temperatureChange = "D"
                    } else {
                        this.temperatureChange = "-"
                    }

                    this.piData2.data.labels = labels;
                    this.piData2.data.datasets[0].data = datasetOne;     
                    this.humidity = datasetOne[29]      
                    
                    if(this.humidity > datasetOne[28]) {
                        this.humidityChange = "U"
                    } else if(this.humidity < datasetOne[28]) {
                        this.humidityChange = "D"
                    } else {
                        this.humidityChange = "-"
                    }                
                    
                    // Temperature  Chart
                    const ctx = document.getElementById('device-chart');
                    new Chart(ctx, this.piData);       
                    
                    // Humidity  Chart
                    const ctx2 = document.getElementById('device-chart-2');
                    new Chart(ctx2, this.piData2);            
                    
                    document.getElementById("live-data-loading").style.display = 'none';
                    document.getElementById("live-data-container").style.display = 'block';                

                } catch (error) {
                    console.log(error);
                }
            },
        }
    }
</script>

<style>
    .card-title {
        font-size: 20px;
    }

    #data-modal-sys-info > #info-table td {
        padding-bottom: 0px;
    }

    #data-modal-sys-info .progress-bar {
        background-color: #76b8e0eb;
    }

    #info-table td {
        border: none;
        padding: 0;
        padding-bottom: 8px;
    }

    #info-table .info-title {
        padding-right: 35px;
    }

    .rotate {
        animation: rotation 8s infinite linear;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }

    .content-container {
        width: 217px;
    }

    .bigTempDataContainer {
        position: relative;
        /* margin-top: -5px; */
    }

    .bigTempDataContainer i {
        position: absolute;
        top: 9px;
        left: 6px;
    }

    .bigTempDataContainer img {
        position: absolute;
        height: 32px;
        top: 9px;
        left: 8px;
    }

    .bigTempData {
        font-size: 32px; 
        text-align: right;
    }

    .belowZero {
        color: #0a58ca;
    }

    .smallTempData {
        font-size: 16px;
        text-align: right;
        margin-top: -9px;
    }

    #device-data-modalVitrafy-00001 > .modal-dialog,
    #device-data-modalVitrafy-00002 > .modal-dialog,
    #device-data-modalVitrafy-00004 > .modal-dialog,
    #device-data-modalVitrafy-00006 > .modal-dialog,
    #device-data-modalVitrafy-00009 > .modal-dialog {
        max-width: 95% !important;
    }

    .modal-title {
        color: inherit;
        font-size: 1.25rem;
        /* padding-left: 10px; */
    }

    .data-button {
        position: absolute;
        right: 0;
    }

    #device-location-mobile {
        margin-top: 30px;
        display: none !important;
    }

    @media (max-width: 991px) {
        #device-location-desktop {
            display: none !important;
        }
        #device-location-mobile {
            display: block !important;
        }        
        #device-data {
            width: 100% !important;
            padding: 0 !important;
        }
    }

    .k-grid-header {
        box-shadow: rgb(0 0 0 / 20%) 0px 3px 4px 0px, rgb(0 0 0 / 14%) 0px 3px 3px -2px, rgb(0 0 0 / 12%) 0px 1px 8px 0px !important;
    }    
</style>
